import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from "./classes/BaseService";
import { HttpClient } from "@angular/common/http";
import { StorageHelper } from "./helpers/StorageHelper";
import { Global } from './classes/Global';

@Injectable()
export class AuthenticationService extends BaseService{

  apiUrl = "Account.php?";
  loggedIn = false;

  constructor(protected http: HttpClient) {
    super(http);
    this.loggedIn = !!StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
  }

  isLoggedIn(): boolean {
    return this.loggedIn;
  }

  setIsLoggedIn(value: boolean) {
    this.loggedIn = value;
  }

  login(country: string, email: string, password: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "login"),
      new UrlParam("email", email),
      new UrlParam("password", password),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  loginByFb(country: string, email: string, fbToken: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "loginByFb"),
      new UrlParam("email", email),
      new UrlParam("fbToken", fbToken),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  register(country: string, username: string, email: string, password: string, store: string, referralCode: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "register"),
      new UrlParam("username", username),
      new UrlParam("email", email),
      new UrlParam("password", password),
      new UrlParam("store", store),
      new UrlParam("referralCode", referralCode),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  registerByFb(country: string, email: string, fbUserID: string, username: string, store: string, referralCode: string) {
    const url = this.serverUrl + this.apiUrl;
     const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "registerByFb"),
      new UrlParam("email", email),
      new UrlParam("fbUserID", fbUserID),
      new UrlParam("username", username),
      new UrlParam("store", store),
      new UrlParam("referralCode", referralCode),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  logout(country: string, sessionToken: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "logout"),
      new UrlParam(StorageHelper.keys.sessionToken, sessionToken),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  resetPassword(country: string, email: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "resetPassword"),
      new UrlParam("email", email),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  changePassword(country: string, sessionToken: string, password: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "changePassword"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("password", password),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  changeMail(country: string, sessionToken: string, email: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "changeMail"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("email", email),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  changeUsername(country: string, sessionToken: string, username: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "changeUsername"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("username", username),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  deleteAccount(country: string, sessionToken: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "deleteAccount"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  loginByApple(country: string, appleUserID: string, email: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "loginByApple"),
      new UrlParam("email", email),
      new UrlParam("appleUserID", appleUserID),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  registerByApple(country: string, appleUserID: string, email: string, username: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "registerByApple"),
      new UrlParam("email", email),
      new UrlParam("username", username),
      new UrlParam("appleUserID", appleUserID),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  doesAccountExist(email: string, country: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "doesAccountExist"),
      new UrlParam("country", country),
      new UrlParam("email", email),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.get(url);
  }

  changeProviderToApple(country: string, appleUserID: string, email: string, sessionToken: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "changeProviderToApple"),
      new UrlParam("email", email),
      new UrlParam("appleUserID", appleUserID),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

}
